/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Tab_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Media versions" |
*
* @param {Media_Tab_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_tab_aria_label = /** @type {((inputs?: Media_Tab_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Tab_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Versions médias")
	if (locale === "de") return /** @type {LocalizedString} */ ("Medienversionen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Versioni multimediali")
	if (locale === "ru") return /** @type {LocalizedString} */ ("медиаверсии")
	if (locale === "es") return /** @type {LocalizedString} */ ("Versiones multimedia")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("媒体版本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メディア版")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मीडिया संस्करण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Versões para mídia")
	return /** @type {LocalizedString} */ ("Media versions")
});